import React from "react";

export default function AssignmentTableHead() {
  return (
    <thead>
      <tr>
        <th className="table-th">Title</th>
        <th className="table-th">Video Title</th>
        <th className="table-th">Mark</th>
        <th className="table-th">Action</th>
      </tr>
    </thead>
  );
}
